/* eslint-disable @typescript-eslint/no-var-requires */

export const IllusUpsellCtaBg = require('./Illus-UpsellCtaBg.png');
